<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Detail">
        <dpi-step-recom-detail></dpi-step-recom-detail>
    </mat-tab>
    <mat-tab label="Photos">
        <ng-template mat-tab-label>
            <span matBadge="{{pictureNum}}" [matBadgeHidden]="pictureNum === 0" matBadgeOverlap="false" class="tab_recommendation_badge">Photos</span>
        </ng-template>
        <dpi-step-recom-picture (listSizeChanged)="setPictureNum($event)"></dpi-step-recom-picture>
    </mat-tab>
</mat-tab-group>
